export default "__VITE_ASSET__5942c353__"